import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import Reveal from '@/components/base/Reveal';
import { CATEGORIES } from '@/config/site';
import { topics } from '@/mocks/topics';

export default function CategorySection() {
  const countOf = (name: string) => topics.filter((t) => t.category === name).length;

  return (
    <section className="w-full bg-secondary-50 py-14 md:py-20" id="categories">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Categories"
            title="按主题找话题"
            desc="六大分类覆盖娱乐、影视、消费、科技、体育与公共议题，点进去就能看到该领域的实时讨论。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 50}>
              <Link
                to={`/topics?category=${encodeURIComponent(c.name)}`}
                className="group flex h-full cursor-pointer flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-2xl text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                  <i className={c.icon} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950 group-hover:text-primary-600">{c.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span>{countOf(c.name)} 个进行中话题</span>
                  <i className="ri-arrow-right-line text-base text-primary-500 transition-transform group-hover:translate-x-1" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}